Immutable = require 'seamless-immutable'
{ did, doing } = require './common'
{ CREATED_SCHOOL, CREATING_SCHOOL, DELETED_SCHOOL, DELETING_SCHOOL, FETCHED_SCHOOLS, FETCHING_SCHOOLS, SELECT_SCHOOL, UPDATED_SCHOOL, UPDATING_SCHOOL } = require '../actions/schools'

baseState = Immutable {
	list: []
	isCreating: false
	isDeleting: false
	isFetching: false
	isUpdating: false
	selected: null
}

schools = (state = baseState, action) ->
	switch action.type
		when CREATING_SCHOOL
			state = doing 'isCreating', state
		when CREATED_SCHOOL
			state = did 'isCreating', state, action
		when DELETING_SCHOOL
			state = doing 'isDeleting', state
		when DELETED_SCHOOL
			state = did 'isDeleting', state, action
		when FETCHING_SCHOOLS
			state = doing 'isFetching', state
		when FETCHED_SCHOOLS
			state = did 'isFetching', state, action
		when SELECT_SCHOOL
			if action.payload.school
				localStorage.setItem 'school', action.payload.school.id
			else
				localStorage.removeItem 'school'

			state = state.set 'selected', Immutable action.payload.school
		when UPDATING_SCHOOL
			state = doing 'isUpdating', state
		when UPDATED_SCHOOL
			state = did 'isUpdating', state, action
	state

module.exports = schools



// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/schools.coffee